import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import { AccountLayout } from '../components/account/layout';
import { Loading } from '../components/loading/loading';
import { style } from 'typestyle';
import { em, px } from 'csx';
import {ButtonPill} from '../components/button-pill';
import {FormDetails} from '../components/form-details';
import {FormMarketingPreferencesModal} from '../components/form-marketing-preferences-modal';
import {colorSubtle} from '../theme/color';
import {COUNTRIES, LANGUAGES} from '../constants';
import {AccountCommunicationPage} from './account-communication';

export interface AccountProfileProps {
  i18n?: {
    detailsTitle: string;
    detailsEdit: string;
    marketingTitle: string;
    marketingEdit: string;
    dataTitle: string;
    dataEdit: string;
    dangerTitle: string;
    dangerEdit: string;
    emptyValue: string;
  }
}

@inject(deps) @observer
export class AccountProfilePage extends Component<AccountProfileProps> {
  render() {
    const { i18n = AccountProfilePage.i18n } = this.props;
    const model = this.props.model.page.accountProfile;
    const controller = this.props.controller.page.accountProfile;
    const modalController = this.props.controller.modal;
    
    if (model.loading) return (
      <AccountLayout>
        <div className={AccountCommunicationPage.styles.containerLoading}>
          <Loading />
        </div>
      </AccountLayout>
    );

    const { user } = this.props.model.user;
    const genre = user && this.props.model.content.genres.find(g => g.slug === user.preferred_genre);
    const countryName = COUNTRIES[user.country];

    return (
      <AccountLayout>
        <div className={AccountProfilePage.styles.block}>
          <h3>{i18n.detailsTitle}</h3>
          {!model.modalDetails.show && (
            <dl className={AccountProfilePage.styles.definitions}>
              <dt>Email</dt>
              <dd>{user.email}</dd>
              <dt>First name</dt>
              <dd>{user.first_name}</dd>
              <dt>Last name</dt>
              <dd>{user.last_name}</dd>
              <dt>Country</dt>
              <dd>{countryName}</dd>
              <dt>Language</dt>
              <dd>{LANGUAGES[user.language] || i18n.emptyValue}</dd>
              <dt>Telephone</dt>
              <dd>{user.telephone || i18n.emptyValue}</dd>
              <dt>Is business</dt>
              <dd>{user.is_business ? 'Yes' : 'No'}</dd>
              <dt>Preferred genre</dt>
              <dd>{genre ? genre.label : i18n.emptyValue}</dd>
              <dt>How did you find us?</dt>
              <dd>{user.found_us ? user.found_us : i18n.emptyValue}</dd>
            </dl>
          )}
          {!model.modalDetails.show && (
            <ButtonPill onClick={() => controller.editDetails()}>
              {i18n.detailsEdit}
            </ButtonPill>
          )}
          {model.modalDetails.show && (
            <FormDetails
              model={model.modalDetails.form}
              onChange={controller.changeDetailsField}
              onSubmit={controller.submitDetailsModal}
              onCancel={controller.closeDetailsModal}
            />
          )}
        </div>
        <div className={AccountProfilePage.styles.block}>
          <h3>{i18n.marketingTitle}</h3>
          <dl className={AccountProfilePage.styles.definitions}>
            <dt>Allow marketing</dt>
            <dd>{user.marketing_allowed ? `Yes` : `No`}</dd>
          </dl>
          <ButtonPill onClick={() => controller.editMarketing()}>
            {i18n.marketingEdit}
          </ButtonPill>
          <FormMarketingPreferencesModal
            model={model.modalMarketing}
            onChange={controller.changeMarketingField}
            onSubmit={controller.submitMarketingModal}
            onRequestClose={controller.closeMarketingModal}
            onCancel={controller.closeMarketingModal}
          />
        </div>
        <div className={AccountProfilePage.styles.block}>
          <h3>{i18n.dataTitle}</h3>
          <ButtonPill onClick={() => modalController.showDownloadAccountDataModal()}>
            {i18n.dataEdit}
          </ButtonPill>
        </div>
        <div className={AccountProfilePage.styles.block}>
          <h3>{i18n.dangerTitle}</h3>
          <ButtonPill className={ButtonPill.styles.danger} onClick={() => modalController.showDeleteAccountModal()}>
            {i18n.dangerEdit}
          </ButtonPill>
        </div>
      </AccountLayout>
    )
  }

  static i18n = {
    detailsTitle: 'My details',
    detailsEdit: 'Edit details',
    marketingTitle: 'My marketing preferences',
    marketingEdit: 'Edit marketing preferences',
    dataTitle: 'My data',
    dataEdit: 'Download my data',
    dangerTitle: 'Danger zone',
    dangerEdit: 'Delete my account',
    emptyValue: '-',
  };

  static styles = {
    block: style({
      marginBottom: px(40),
      maxWidth: px(600)
    }),
    definitions: style({
      margin: '1em 0',
      $nest: {
        '& dt': {
          margin: 0,
          padding: 0,
          fontSize: px(12),
          lineHeight: em(1.1),
          color: colorSubtle.toString()
        },
        '& dd': {
          margin: '0 0 1em 0'
        },
        '& dd:last-child': {
          margin: 0
        }
      }
    })
  };
}